export default "__VITE_ASSET__DjON6PLF__"